/**************************************************
 * Nombre:       Formulario_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import {
    AccountCircleOutlined,
    EmojiFlagsOutlined,
    EventAvailableOutlined,
    Google,
    MoneyOutlined,
    NumbersOutlined
} from "@mui/icons-material";
import IngresoSelect from "../../../Modulo_formularios/Componentes/IngresoSelect";
import IngresoDinero from "../../../Modulo_formularios/Componentes/IngresoDinero";
import {ESTADOCONTRATOS, ESTADOSCONTRATO} from "../../../Constantes";
import IngresoFecha from "../../../Modulo_formularios/Componentes/IngresoFecha";

const Formulario_Contrato = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={6}>
                    <IngresoTexto Icono={NumbersOutlined} nombre={'Consecutivo'} dato={'consecutivo'} {...props}
                                  editable={false}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoSelect Icono={EmojiFlagsOutlined} nombre={'Estado'} dato={'estado'} {...props}
                                   opciones={ESTADOSCONTRATO.map((it) => it.nombre)}
                    />
                </Grid>


                <Grid container size={6}>
                    <IngresoDinero Icono={MoneyOutlined} nombre={'Valor'} dato={'valor'} {...props}/>
                </Grid>

                <Grid container size={6}>
                    <IngresoFecha Icono={EventAvailableOutlined} nombre={'Fecha Incio'} dato={'fechaInicio'} {...props}/>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombre de Usuario'} dato={'nombre'} {...props}
                                  requerido={'El Nombre es requerido'} editable={false}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={Google} nombre={'Correo'} dato={'correo'} {...props}
                                  editable={false}/>
                </Grid>

            </Grid>

        </form>

    )

}
export default Formulario_Contrato